module.exports = __webpack_public_path__ + "img/4.f6f6a341.png";